import {
  CollectionPage,
  GeoCoordinates,
  OfferCatalog,
  Place,
  Map,
  AggregateOffer,
  BreadcrumbList
} from 'schema-dts';
import { JsonLd } from './JsonLD';
import { SCHEMA_TYPES } from './SchemaBuilder';

function CollectionPageSchema(props: {
  pageProps: any;
  schemaType: SCHEMA_TYPES;
  locale?: string;
}) {
  const { pageProps, schemaType } = props;

  const x = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: 'Sahel Map: Check Out All North Coast Resorts & Compounds - Nawy',
    description:
      'Explore the Nawy Sahel Map to discover top compounds in Egypt’s North Coast, including Ras El Hekma, Sidi Abdel Rahman, and Al Alamein. Find the best properties & villas & chalets for sale',
    url: 'https://www.nawy.com/map/sahel-map',
    about: {
      '@type': 'Place',
      name: 'North Coast - Sahel, Egypt',
      geo: {
        '@type': 'GeoCoordinates',
        latitude: '31.0000',
        longitude: '28.0000'
      }
    },
    mainEntity: {
      '@type': 'Map',
      name: 'North Coast - Sahel Compounds Map',
      url: 'https://www.nawy.com/map/sahel-map'
    },
    offers: {
      '@type': 'AggregateOffer',
      priceCurrency: 'EGP',
      lowPrice: '14300000',
      highPrice: '56300000',
      offerCount: 51
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: 'https://www.nawy.com'
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: ' Sahel Map',
          item: 'https://www.nawy.com/map/sahel-map'
        }
      ]
    }
  };

  const collectionPage: CollectionPage =
    props?.locale === 'en'
      ? {
          '@type': 'CollectionPage',
          name: 'Check out the Best Real Estate Egypt Offers - Nawy',
          image: 'https://www.nawy.com/assets/icons/common/nawy.svg',
          description:
            'Explore the best real estate Egypt offers & discounts, from the top developers in various compounds. Get your home with Nawy with the best prices & deals',
          url: 'https://www.nawy.com/real-estate-offers',
          mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': 'https://www.nawy.com/real-estate-offers'
          }
        }
      : {
          '@type': 'CollectionPage',
          name: 'اكتشف أفضل عروض عقارية في مصر والحصرية من ناوي - Nawy',
          image: 'https://www.nawy.com/assets/icons/common/nawy.svg',
          description:
            'سواء كنت مستثمرًا عقاريًا، أو حتى تبحث عن منزلك، أو ربما وحدة لتبدأ أعمالك؛ اعرف أفضل عروض عقارية  في مصر، وانتهز الفرصة وبادر بالشراء بأفضل خطط الدفع والسداد!',
          url: 'https://www.nawy.com/ar/real-estate-offers',
          mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': 'https://www.nawy.com/ar/real-estate-offers'
          }
        };

  const offerCatalog: OfferCatalog =
    props?.locale === 'en'
      ? {
          '@type': 'OfferCatalog',
          name: 'Exclusive Offers & Discounts from Nawy Real Estate',
          description:
            'Exclusive property offers including up to 10-year installment plans with 0% down payment, instant cash discounts, cashback deals, and flexible payment options.',
          url: 'https://www.nawy.com/real-estate-offers',
          numberOfItems: pageProps?.initialOffers?.length || 0,
          image: 'https://www.nawy.com/assets/icons/common/nawy.svg'
        }
      : {
          '@type': 'OfferCatalog',
          name: 'عروض وخصومات حصرية من ناوي للعقارات',
          description:
            'عروض حصرية تتنوع بين تقسيط حتى 10 سنوات بدون مقدم، خصومات فورية عند الدفع الكاش، استرداد نقدي، وخطط سداد مرنة ومتنوعة',
          url: 'https://www.nawy.com/ar/real-estate-offers',
          numberOfItems: pageProps?.initialOffers?.length || 0,
          image: 'https://www.nawy.com/assets/icons/common/nawy.svg'
        };

  const geoCoordinates: GeoCoordinates = {
    '@type': 'GeoCoordinates',
    latitude: '31.0000',
    longitude: '28.0000'
  };

  const place: Place =
    props.locale === 'en'
      ? {
          '@type': 'Place',
          name: 'North Coast - Sahel, Egypt',
          geo: geoCoordinates
        }
      : {
          '@type': 'Place',
          name: 'الساحل الشمالي، مصر',
          geo: geoCoordinates
        };

  const map: Map =
    props.locale === 'en'
      ? {
          '@type': 'Map',
          name: 'North Coast - Sahel Compounds Map',
          url: 'https://www.nawy.com/map/sahel-map'
        }
      : {
          '@type': 'Map',
          name: 'خريطة كمبوندات الساحل الشمالي',
          url: 'https://www.nawy.com/ar/map/sahel-map'
        };

  const aggregateOffer: AggregateOffer = {
    '@type': 'AggregateOffer',
    priceCurrency: 'EGP',
    lowPrice: '14300000',
    highPrice: '56300000',
    offerCount: 51
  };

  const breadcrumbs: BreadcrumbList = {
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: 'https://www.nawy.com'
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: ' Sahel Map',
        item: 'https://www.nawy.com/map/sahel-map'
      }
    ]
  };

  const sahelMapCollectionPage: CollectionPage =
    props?.locale === 'en'
      ? {
          '@type': 'CollectionPage',
          name: 'Sahel Map: Check Out All North Coast Resorts & Compounds - Nawy',
          description:
            'Explore the Nawy Sahel Map to discover top compounds in Egypt’s North Coast, including Ras El Hekma, Sidi Abdel Rahman, and Al Alamein. Find the best properties & villas & chalets for sale',
          url: 'https://www.nawy.com/map/sahel-map',
          about: place,
          mainEntity: map,
          offers: aggregateOffer,
          breadcrumb: breadcrumbs
        }
      : {
          '@type': 'CollectionPage',
          name: 'تصفح خريطة الساحل الشمالي وامتلك وحدتك بأفضل الأسعار - Nawy',
          description:
            'تصفح خريطة الساحل الشمالي واكتشف أفضل المشاريع في رأس الحكمة والعلمين وسيدي عبد الرحمن، وامتلك وحدتك من بين مجموعة شاليهات وشقق وفلل للبيع في الساحل الشمالي بأفضل الأسعار',
          url: 'https://www.nawy.com/ar/map/sahel-map',
          about: place,
          mainEntity: map,
          offers: aggregateOffer,
          breadcrumb: breadcrumbs
        };

  switch (schemaType) {
    case SCHEMA_TYPES.collection_page:
      return JsonLd<CollectionPage>('collectionPage-schema', {
        '@context': 'https://schema.org',
        ...collectionPage,
        mainEntity: offerCatalog
      });
    case SCHEMA_TYPES.map_collection_page:
      return JsonLd<CollectionPage>('collectionPage-schema', {
        '@context': 'https://schema.org',
        ...sahelMapCollectionPage
      });
    default:
      return null;
  }
}

export default CollectionPageSchema;
